export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'entertainment', name: '娱乐圈', icon: 'ri-movie-2-line' },
  { slug: 'social', name: '社会热点', icon: 'ri-fire-line' },
  { slug: 'tech', name: '科技数码', icon: 'ri-smartphone-line' },
  { slug: 'finance', name: '财经商业', icon: 'ri-funds-line' },
  { slug: 'sports', name: '体育竞技', icon: 'ri-basketball-line' },
];

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    slug: 'top-star-scandal-2025',
    title: '某顶流明星私生活混乱被实锤？知情人曝光大量聊天记录与照片',
    excerpt: '近日，某知名顶流艺人被曝出私生活混乱，多位知情人联合爆料，提供了大量聊天记录截图和私密照片，引发全网热议。',
    content: `<p>近日，娱乐圈再次掀起轩然大波。某位长期占据热搜榜首的顶流明星被多位知情人联合曝光其私生活混乱的真相。</p>
<p>据知情人士透露，该艺人在过去几年间与多名异性保持不正当关系，并且利用自身影响力对受害者施压，试图掩盖真相。</p>
<h3>聊天记录曝光</h3>
<p>爆料者提供了大量该艺人与不同对象的聊天记录截图，内容涉及约会安排、情感纠葛以及金钱交易。这些聊天记录的时间跨度长达三年之久，显示该艺人在同一时间段内与多人保持密切联系。</p>
<p>从曝光的聊天内容来看，该艺人多次以"工作繁忙""需要理解"等理由搪塞各方，同时在不同对象之间游刃有余地维持着多段关系。</p>
<h3>照片证据</h3>
<p>除了聊天记录外，爆料者还公布了多张私密照片，包括该艺人与不同异性出入酒店、私人会所等场所的画面。这些照片的拍摄时间与聊天记录高度吻合，进一步佐证了爆料的真实性。</p>
<h3>粉丝反应两极分化</h3>
<p>消息传出后，该艺人的粉丝群体迅速分裂为两派。一部分粉丝坚决否认爆料内容，认为这是竞争对手的恶意抹黑；另一部分粉丝则表示失望透顶，纷纷脱粉回踩。</p>
<h3>艺人团队暂未回应</h3>
<p>截至目前，该艺人的经纪团队尚未对此次爆料做出任何正式回应。有媒体尝试联系其经纪人，但电话始终无人接听。业内人士分析认为，沉默可能意味着爆料内容确有其事，团队正在紧急商讨应对策略。</p>
<p>本网将持续关注此事进展，为读者带来最新报道。</p>`,
    category: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20silhouette%20of%20a%20person%20on%20stage%20surrounded%20by%20flashing%20paparazzi%20cameras%2C%20moody%20atmosphere%20with%20deep%20shadows%20and%20warm%20spotlight%2C%20cinematic%20photography%20style%20with%20film%20grain%2C%20mysterious%20and%20tense%20mood&width=800&height=450&seq=article-ent-01&orientation=landscape',
    author: '黑料网编辑部',
    publishDate: '2025-08-06',
    readCount: 128500,
    tags: ['娱乐圈', '顶流明星', '私生活', '聊天记录'],
    isHot: true,
    isNew: true,
  },
  {
    slug: 'tech-giant-data-breach',
    title: '某科技巨头涉嫌大规模数据泄露，数亿用户信息被暗中出售',
    excerpt: '内部人士举报某头部科技公司存在严重数据安全问题，数亿用户的个人信息被非法导出并在地下市场交易，涉及金额巨大。',
    content: `<p>近日，一位自称是某科技巨头前员工的人士向本网举报，称该公司存在严重的数据安全漏洞，且管理层对此心知肚明却选择隐瞒。</p>
<p>据举报人提供的材料显示，该公司在过去两年间发生了至少三次大规模数据泄露事件，涉及超过3亿用户的个人信息。</p>
<h3>泄露数据类型</h3>
<p>被泄露的用户数据包括但不限于：真实姓名、手机号码、身份证号、家庭住址、消费记录、位置轨迹等高度敏感信息。这些数据在地下黑市以每条0.5至5元不等的价格被批量出售。</p>
<h3>内部知情人士揭秘</h3>
<p>举报人透露，该公司的数据安全团队早在2024年初就发现了异常数据外流的情况，但上报后遭到高层压制。"他们担心公开披露会影响股价和下一轮融资，"举报人表示，"所以选择用'技术故障'来搪塞内部质疑。"</p>
<h3>监管部门介入调查</h3>
<p>据悉，相关监管部门已经注意到了这一情况，并已启动初步调查程序。如果举报内容属实，该公司可能面临巨额罚款以及刑事责任追究。</p>
<p>本网将持续关注此事件的后续发展。</p>`,
    category: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20blinking%20red%20warning%20lights%2C%20glowing%20data%20cables%2C%20ominous%20atmosphere%2C%20cybersecurity%20threat%20concept%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20cinematic%20mystery%20mood&width=800&height=450&seq=article-tech-01&orientation=landscape',
    author: '黑料网科技组',
    publishDate: '2025-08-05',
    readCount: 95600,
    tags: ['科技', '数据泄露', '隐私安全', '信息安全'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'real-estate-tycoon-debt-crisis',
    title: '百亿地产大佬资金链断裂内幕：质押股权被强制平仓，豪宅被查封',
    excerpt: '曾身价百亿的某知名地产大亨近日陷入严重的债务危机，多处豪宅被法院查封，质押的上市公司股权被强制平仓。',
    content: `<p>曾经在房地产市场上呼风唤雨的某知名地产大亨，如今正面临着前所未有的财务困境。据多方消息源证实，该大亨的多个项目已停工超过半年，资金链完全断裂。</p>
<h3>债务规模惊人</h3>
<p>根据公开信息以及内部人士透露，该地产大亨目前的总负债规模可能超过500亿元人民币，涉及银行、信托、民间借贷等多个渠道。其中仅银行不良贷款就高达200亿元以上。</p>
<h3>豪宅被查封</h3>
<p>近期，法院已对该大亨名下的多处豪宅进行了查封处理。这些房产分布于北京、上海、深圳、香港等核心城市，总价值估计超过30亿元。其中一套位于香港山顶的豪宅估值高达8亿港币。</p>
<h3>股权被强制平仓</h3>
<p>由于无法按时偿还质押贷款，该大亨质押的多家上市公司股权已被券商强制平仓。这一举动进一步引发了股价暴跌，造成了连锁反应，波及了大量中小投资者。</p>
<h3>员工讨薪潮</h3>
<p>据悉，该大亨旗下多家公司已拖欠员工工资长达半年之久。大量员工通过网络平台发起了集体讨薪行动，部分地区的劳动监察部门已介入调解。</p>
<p>这一事件再次警示了高杠杆扩张模式的风险，也引发了业界对于房地产行业健康发展的深刻反思。</p>`,
    category: 'finance',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20with%20foreclosure%20notice%20on%20the%20gate%2C%20dark%20stormy%20sky%2C%20dramatic%20moody%20atmosphere%2C%20wealth%20and%20crisis%20contrast%2C%20cinematic%20photography%20with%20deep%20shadows&width=800&height=450&seq=article-fin-01&orientation=landscape',
    author: '黑料网财经组',
    publishDate: '2025-08-04',
    readCount: 187200,
    tags: ['财经', '房地产', '债务危机', '富豪'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'sports-star-match-fixing',
    title: '知名体育明星涉嫌打假球？神秘账户异常投注记录被曝光',
    excerpt: '某体育明星被曝涉嫌参与赌球和操纵比赛结果，其关联账户在关键比赛中出现了异常的大额投注记录，引发业内震动。',
    content: `<p>体育界再传重磅丑闻。一位在国内极具影响力的体育明星被曝涉嫌参与赌球和操纵比赛结果，多个与其关联的神秘账户被发现在关键比赛中有异常投注行为。</p>
<h3>异常投注记录</h3>
<p>根据某博彩监控机构提供的数据，在过去一年中，有数个与这位体育明星存在关联的账户在至少8场比赛中出现了高度可疑的投注模式。这些投注往往在比赛结果公布的数小时前就已经精准下注，胜率高达90%以上。</p>
<h3>内部人士说法</h3>
<p>一位不愿透露姓名的业内人士表示："这个圈子里很多人都知道这件事，但没人敢说。这位明星背后的利益集团太强大了，涉及赞助商、俱乐部、媒体等多个层面。"</p>
<h3>协会表态</h3>
<p>相关体育协会已发表声明，表示将对此事展开调查，并承诺"绝不姑息任何破坏体育公平精神的行为"。但截至目前，尚未公布具体的调查进展。</p>
<p>如果此事属实，这将是近年来国内体坛最大的一起假球丑闻。</p>`,
    category: 'sports',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20stadium%20at%20night%20with%20single%20spotlight%20on%20empty%20field%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20sports%20scandal%20theme%2C%20cinematic%20noir%20style%20photography&width=800&height=450&seq=article-spt-01&orientation=landscape',
    author: '黑料网体育组',
    publishDate: '2025-08-03',
    readCount: 76300,
    tags: ['体育', '假球', '赌球', '操纵比赛'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'internet-celebrity-tax-evasion',
    title: '头部网红偷税漏税超2亿？税务机关已介入调查并冻结相关账户',
    excerpt: '某社交平台头部网红被举报涉嫌通过虚假合同、境外账户等方式偷逃税款，涉案金额高达2亿元以上，税务机关已开展专项调查。',
    content: `<p>近日，税务部门对某知名网络主播展开了全面的税务稽查行动。据知情人士透露，该主播在过去三年内通过多种手段偷逃税款，涉案金额可能超过2亿元人民币。</p>
<h3>逃税手法揭秘</h3>
<p>根据举报材料，该主播的主要逃税手法包括：通过设立空壳公司签订虚假服务合同转移收入；利用境外账户接收广告费用和打赏收入；将个人劳务报酬伪装成企业间交易以适用更低税率。</p>
<h3>账户被冻结</h3>
<p>目前，税务机关已联合金融监管部门对该主播及其关联公司名下的多个银行账户实施了冻结措施。涉及资金总额约1.5亿元。该主播名下的多处房产和豪车也被采取了保全措施。</p>
<h3>行业震动</h3>
<p>此事件在整个直播和短视频行业引发了强烈震动。多位头部主播已经开始主动补缴税款，并表示将加强税务合规管理。业内人士预计，这将是整个行业规范化发展的一个重要转折点。</p>`,
    category: 'social',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20items%20including%20designer%20bags%20and%20sports%20car%20keys%20on%20a%20marble%20table%20with%20tax%20documents%2C%20dramatic%20side%20lighting%2C%20moody%20and%20tense%20atmosphere%2C%20cinematic%20photography&width=800&height=450&seq=article-soc-01&orientation=landscape',
    author: '黑料网社会组',
    publishDate: '2025-08-02',
    readCount: 214500,
    tags: ['社会', '网红', '偷税漏税', '税务稽查'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'film-investment-fraud',
    title: '影视投资骗局大起底：百名投资人被骗，涉案金额超10亿',
    excerpt: '一家号称拥有多个大IP影视项目的投资公司被曝实为庞氏骗局，全国数百名投资者血本无归，幕后操盘手已潜逃海外。',
    content: `<p>一场精心策划的影视投资骗局近日浮出水面。一家名为"星耀影业"的公司以投资热门影视项目为名，在全国范围内吸引了数百名投资者，涉案金额超过10亿元人民币。</p>
<h3>骗局运作模式</h3>
<p>据受害者反映，该公司通过举办豪华路演、邀请明星站台、展示伪造的项目批文等方式，营造出实力雄厚、资源丰富的假象。公司声称拥有多个与一线导演和演员合作的大IP项目，承诺年化回报率高达30%至50%。</p>
<h3>资金去向成谜</h3>
<p>调查发现，该公司所谓的影视项目大多子虚乌有，少数立项的项目也从未实际拍摄。投资者的资金被用于支付前期投资者的"收益"以及公司核心成员的奢侈消费。目前，公司核心管理层已失联，疑已携款潜逃至东南亚。</p>
<h3>受害者众</h3>
<p>受害者遍布全国各地，包括退休老人、中小企业主、白领阶层等。其中一位来自广州的投资者表示，他在该平台上投入了全部积蓄约500万元，如今血本无归。</p>
<p>警方已对此案立案侦查，并发布了在逃人员通缉令。</p>`,
    category: 'social',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20office%20with%20scattered%20investment%20documents%20on%20the%20floor%2C%20overturned%20chairs%2C%20dark%20atmosphere%20with%20sunlight%20streaming%20through%20blinds%2C%20fraud%20crime%20scene%2C%20cinematic%20noir&width=800&height=450&seq=article-soc-02&orientation=landscape',
    author: '黑料网社会组',
    publishDate: '2025-08-01',
    readCount: 168900,
    tags: ['社会', '投资骗局', '影视', '庞氏骗局'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'ai-company-internal-strife',
    title: 'AI独角兽内斗升级：联合创始人被架空，核心技术团队集体出走',
    excerpt: '国内某估值超百亿的AI独角兽公司爆发严重内斗，联合创始人兼CTO被董事会架空，随后核心算法团队十余人集体辞职。',
    content: `<p>曾被资本市场寄予厚望的某AI独角兽公司，近期陷入了前所未有的内部危机。公司联合创始人兼首席技术官被董事会投票罢免，随后引发了核心技术团队的大规模离职潮。</p>
<h3>内斗始末</h3>
<p>据内部员工透露，矛盾的根源在于公司CEO与CTO之间对于技术路线和商业化策略的根本分歧。CTO主张继续深耕底层算法的研发，而CEO则希望快速推出面向消费者的产品以实现盈利。</p>
<h3>团队出走</h3>
<p>在CTO被架空后，核心算法团队的15名成员中有12人提交了辞职申请。这些成员大多是公司的早期技术骨干，掌握着公司最核心的技术秘密。他们的离开被业内人士视为对该公司技术实力的致命打击。</p>
<h3>投资人担忧</h3>
<p>多位投资方代表已紧急约见公司管理层，表达了对事态发展的严重关切。有投资人私下表示，如果核心技术团队流失，将考虑启动对赌协议中的回购条款。</p>
<p>这一事件再次引发了业界对于AI创业公司治理结构的深入讨论。</p>`,
    category: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Empty%20modern%20tech%20office%20with%20abandoned%20desks%20and%20chairs%2C%20dim%20lighting%2C%20resignation%20letters%20on%20desk%2C%20corporate%20turmoil%20atmosphere%2C%20dramatic%20moody%20photography&width=800&height=450&seq=article-tech-02&orientation=landscape',
    author: '黑料网科技组',
    publishDate: '2025-07-31',
    readCount: 89200,
    tags: ['科技', 'AI', '内斗', '创业公司'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'celebrity-divorce-property-battle',
    title: '明星夫妻离婚内幕曝光：财产分割争议升级，双方互爆黑料',
    excerpt: '一对知名明星夫妻的离婚官司愈演愈烈，双方不再顾及体面，开始在社交媒体上互相曝光对方的不堪往事，引发全民围观。',
    content: `<p>曾经被誉为娱乐圈模范夫妻的一对明星夫妇，如今正在上演一场令人唏嘘的离婚大战。随着离婚官司的推进，双方之间的火药味越来越浓，已从法庭延伸到了社交媒体平台。</p>
<h3>财产争夺</h3>
<p>据了解，这对夫妻的共同财产估值超过5亿元，包括多处豪宅、豪车收藏以及数家公司的股权。双方在财产分割方案上存在巨大分歧，各执一词，调解多次失败。</p>
<h3>互爆黑料</h3>
<p>近一周来，双方开始在社交媒体上频繁发文，互相指控对方的过错。女方指控男方长期出轨多名异性，并提供了部分聊天记录作为证据；男方则反击称女方挥霍无度、不尊重长辈，并暗示女方也有婚外情。</p>
<h3>子女抚养权之争</h3>
<p>除了财产纠纷外，两人对于两个未成年子女的抚养权也争夺激烈。据悉，双方都希望获得主要抚养权，而法院倾向于根据儿童最大利益原则做出裁决。</p>
<p>这场离婚大战已成为近期社交媒体上最热门的话题之一。</p>`,
    category: 'entertainment',
    coverImage: 'https://readdy.ai/api/search-image?query=Cracked%20wedding%20ring%20on%20dark%20surface%20with%20divorce%20papers%20scattered%20around%2C%20dramatic%20side%20lighting%2C%20emotional%20breakup%20theme%2C%20cinematic%20photography%20with%20deep%20shadows&width=800&height=450&seq=article-ent-02&orientation=landscape',
    author: '黑料网编辑部',
    publishDate: '2025-07-30',
    readCount: 203100,
    tags: ['娱乐圈', '离婚', '财产分割', '明星夫妻'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'ecommerce-platform-fake-reviews',
    title: '电商平台刷单内幕：一条虚假好评产业链被连根拔起',
    excerpt: '某知名电商平台内部员工勾结外部刷单团伙，通过虚假交易和好评操纵商品排名，严重损害消费者权益，已被警方一网打尽。',
    content: `<p>电商刷单产业链再次被揭开冰山一角。近日，警方成功破获了一起涉及某头部电商平台的大规模刷单案件，抓获犯罪嫌疑人40余名，涉案金额超过5000万元。</p>
<h3>内外勾结</h3>
<p>调查显示，该刷单团伙与电商平台内部多名员工存在长期的利益勾连。内部员工利用职务之便，为刷单团伙提供算法漏洞信息、规避风控的策略建议，甚至直接帮助修改后台数据。</p>
<h3>刷单手法</h3>
<p>该团伙采用了多种刷单手法：通过购买大量虚拟手机号注册虚假买家账号；利用物流空包服务生成虚假物流信息；雇佣写手批量生产虚假好评内容。一个商品的刷单量可达数千甚至上万条。</p>
<h3>平台回应</h3>
<p>事件曝光后，涉事电商平台发表声明称已开除涉案员工，并表示将升级风控系统、加大打击力度。但消费者权益保护组织指出，平台方在此事件中存在不可推卸的监管责任。</p>`,
    category: 'tech',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20warehouse%20filled%20with%20cardboard%20boxes%20and%20computer%20screens%20showing%20fake%20reviews%2C%20mysterious%20atmosphere%2C%20fraud%20operation%20scene%2C%20dramatic%20noir%20lighting&width=800&height=450&seq=article-tech-03&orientation=landscape',
    author: '黑料网科技组',
    publishDate: '2025-07-29',
    readCount: 134600,
    tags: ['科技', '电商', '刷单', '虚假评价'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'food-safety-scandal-chain-restaurant',
    title: '连锁餐饮品牌后厨乱象：过期食材翻新上桌，卫生状况触目惊心',
    excerpt: '暗访记者在某知名连锁餐饮品牌后厨卧底三个月，拍下了大量令人震惊的画面，过期食材被重新加工后继续给顾客食用。',
    content: `<p>食品安全问题再次敲响警钟。本网暗访记者在某全国连锁餐饮品牌后厨进行了长达三个月的卧底调查，揭露了一系列触目惊心的食品安全隐患。</p>
<h3>过期食材翻新</h3>
<p>暗访画面显示，该餐厅后厨员工将已经过期甚至变质的肉类和蔬菜通过各种手段"翻新"：用化学试剂浸泡去除异味；将发霉部分切除后继续使用剩余部分；更改保质期标签使过期食材"合法化"。</p>
<h3>卫生状况堪忧</h3>
<p>后厨的卫生状况更是令人担忧。蟑螂和老鼠在食材储存区自由活动；厨具长期不清洗消毒；员工在操作过程中不戴手套口罩，甚至徒手处理熟食。</p>
<h3>监管漏洞</h3>
<p>记者发现，每当有监管部门前来检查时，餐厅都会提前接到"通风报信"，紧急进行表面整改以应付检查。这种"猫鼠游戏"已成为行业的公开秘密。</p>
<p>报道发布后，该品牌股价应声下跌超过15%，多个城市门店被勒令停业整顿。</p>`,
    category: 'social',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20dirty%20restaurant%20kitchen%20with%20dim%20lighting%2C%20messy%20food%20preparation%20area%2C%20pest%20problems%2C%20food%20safety%20violation%20theme%2C%20investigative%20journalism%20style%2C%20cinematic&width=800&height=450&seq=article-soc-03&orientation=landscape',
    author: '黑料网社会组',
    publishDate: '2025-07-28',
    readCount: 256800,
    tags: ['社会', '食品安全', '餐饮', '暗访'],
    isHot: true,
    isNew: false,
  },
  {
    slug: 'football-club-financial-fraud',
    title: '中超俱乐部财务造假被揭发：阴阳合同、虚假转会费成常态',
    excerpt: '中国足协近期收到多份举报材料，指控某中超俱乐部在转会交易中大量使用阴阳合同和虚假报表，涉嫌严重的财务欺诈行为。',
    content: `<p>中国足球的财务黑洞再次成为舆论焦点。多家媒体联合调查发现，某中超俱乐部在过去五个赛季中通过一系列复杂的财务操作，涉嫌进行了大规模的财务造假。</p>
<h3>阴阳合同</h3>
<p>调查显示，该俱乐部在外援和国内球员的转会交易中普遍使用"阴阳合同"。对外公布的合同金额远低于实际支付的金额，差额部分通过境外关联公司以"咨询费""肖像权使用费"等名义支付，以规避足协的财政公平政策。</p>
<h3>虚假转会费</h3>
<p>更令人震惊的是，部分球员的转会费被严重虚报。通过虚高的转会费，俱乐部可以将资金通过各种渠道回流到管理层个人的口袋中。据估算，仅过去三个赛季，通过虚假转会费流失的资金就超过2亿元。</p>
<h3>足协调查</h3>
<p>中国足协已表示将成立专项调查组，对该俱乐部的财务问题进行全面审查。如果查实，该俱乐部可能面临扣分、降级甚至被取消注册资格的严厉处罚。</p>`,
    category: 'sports',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20football%20stadium%20office%20with%20piles%20of%20financial%20documents%20and%20contracts%20on%20desk%2C%20dramatic%20moody%20lighting%2C%20corruption%20investigation%20theme%2C%20cinematic%20noir%20photography&width=800&height=450&seq=article-spt-02&orientation=landscape',
    author: '黑料网体育组',
    publishDate: '2025-07-27',
    readCount: 98700,
    tags: ['体育', '足球', '财务造假', '中超'],
    isHot: false,
    isNew: false,
  },
  {
    slug: 'crypto-exchange-rug-pull',
    title: '虚拟币交易所跑路：数十万用户资产归零，创始人携款潜逃',
    excerpt: '某加密货币交易平台突然关闭网站并清空社交媒体账号，数十万用户的数字资产瞬间归零，创始人疑已携带数亿美元潜逃至境外。',
    content: `<p>加密货币市场再次上演"跑路"大戏。一家名为"CoinTrust"的虚拟货币交易平台突然全面关停，数十万用户的数字资产一夜之间化为乌有。</p>
<h3>跑路过程</h3>
<p>据用户反映，该平台在跑路前进行了精心的策划：先是推出高息理财产品吸引用户充值；然后在关闭前一周停止了所有提现功能，声称是"系统升级"；最终在7月26日凌晨彻底关闭了网站和App，清空了所有社交媒体账号。</p>
<h3>损失惨重</h3>
<p>据不完全统计，该平台用户总数超过30万，涉及资金规模可能高达5亿美元。许多用户投入了全部积蓄，有些甚至借贷加杠杆。平台关闭后，大量受害者聚集在维权群中，但面对创始人的跨国潜逃，维权之路异常艰难。</p>
<h3>监管真空</h3>
<p>该事件再次暴露了加密货币市场监管的严重不足。由于该交易所在海外注册，国内监管机构难以直接介入调查。专家呼吁加速推进加密货币监管立法，保护投资者权益。</p>`,
    category: 'finance',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20screens%20showing%20error%20messages%2C%20empty%20office%20with%20abandoned%20chairs%2C%20cryptocurrency%20scam%20theme%2C%20dramatic%20moody%20lighting%2C%20cinematic%20photography&width=800&height=450&seq=article-fin-02&orientation=landscape',
    author: '黑料网财经组',
    publishDate: '2025-07-26',
    readCount: 178300,
    tags: ['财经', '加密货币', '交易所', '跑路'],
    isHot: true,
    isNew: false,
  },
];

export const hotTags = [
  '娱乐圈',
  '数据泄露',
  '偷税漏税',
  '食品安全',
  '投资骗局',
  '离婚',
  '刷单',
  '加密货币',
  '财务造假',
  'AI内斗',
];